import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthModal from "@/components/AuthModal";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Pathway from "@/components/Pathway";
import Trades from "@/components/Trades";
import WorkerDashboard from "@/components/WorkerDashboard";
import Jobs from "@/components/Jobs";
import Employers from "@/components/Employers";
import Manifesto from "@/components/Manifesto";
import ApplyForm from "@/components/ApplyForm";
import Footer from "@/components/Footer";
import AdminDashboard from "@/components/admin/AdminDashboard";

function MarketingSite() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) { e.preventDefault(); lenis.scrollTo(el, { offset: -70 }); }
      }
    };
    document.addEventListener("click", onClick);
    return () => { cancelAnimationFrame(raf); document.removeEventListener("click", onClick); lenis.destroy(); };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Pathway />
        <Trades />
        <WorkerDashboard />
        <Jobs />
        <Employers />
        <Manifesto />
        <ApplyForm />
      </main>
      <Footer />
      <AuthModal />
    </>
  );
}

function Shell() {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen grid place-items-center bg-[#0B0F14]"><div className="font-mono-tech text-[11px] tracking-[0.3em] text-[#FF5E1E] animate-pulse">LOADING…</div></div>;
  }
  if (user?.role === "admin") return <AdminDashboard />;
  return <MarketingSite />;
}

function App() {
  useEffect(() => { document.documentElement.classList.add("dark"); }, []);
  return (
    <div className="App grain min-h-screen bg-[#0B0F14] text-[#F4F6F8] overflow-x-hidden">
      <AuthProvider>
        <Shell />
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
